<template>
    <div class="mypage_wrapper">
        <div class="header">
            <div class="bg_area" :style="{backgroundImage:`url(${require('@/assets/imgs/bg_profile.jpg')})`}">

            </div>
            <div class="menu_area">
                <div class="left_menu menu_block">
                    <base-button-sm :mode="currentMode('myProfile')" link to='/mypage/profile'>내 정보</base-button-sm>
                    <!-- <base-button-sm :mode="currentMode('myFriend')" link to='/mypage/friend'>친구목록</base-button-sm> -->
                    <base-button-sm :mode="currentMode('MyItemBuy')" link to='/mypage/item'>아이템</base-button-sm>
                    <base-button-sm :mode="currentMode('MyGoodsBuy')" link to='/mypage/goods'>P샵상품</base-button-sm>
                    <base-button-sm :mode="currentMode('myChild')" link to='/mypage/mychild'>추천인</base-button-sm>
                    <base-button-sm :mode="currentMode('leave_service')" link to='/mypage/leave_service'>회원탈퇴</base-button-sm>
                </div>                
                   
                <div class="profileImg"                   
                    v-if="user.profile_photo_path"
                    :style="{backgroundImage:`url(${user.profile_photo_url})`}"                   
                    >
                </div> 
                <div class="profileImg"                   
                    v-if="user.profile_url && !user.profile_photo_path"
                    :style="{backgroundImage:`url(${user.profile_photo_url})`}"                   
                    >
                </div> 
                <div class="profileImg"
                    v-if="!user.profile_url && !user.profile_photo_path"         
                    :style="{backgroundImage:`url(${require('@/assets/imgs/profile_blank.jpg')})`}"                   
                    >
                </div>           

                <div class="right_menu  menu_block">
                    <base-button-sm :mode="currentMode('selfAuth')" link to='/mypage/selfauth'>본인인증</base-button-sm>
                    <base-button-sm :mode="currentMode('myFriend')" link to='/mypage/friend'>친구목록</base-button-sm>
                    <base-button-sm :mode="currentMode('myPoint')" link to='/mypage/point'>포인트내역</base-button-sm>
                    <base-button-sm :mode="currentMode('myPost')" link to='/mypage/post'>게시글</base-button-sm>

                </div>
            </div>

        </div>

        <router-view/>
    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
export default {   
    mixins:[ auth ],
    methods:{
        currentMode(link)
        {
            if(link ==='MyItemBuy')
            {
                if(this.$route.name === 'MyItemBuy' || this.$route.name === 'MyItemUse' || this.$route.name === 'MyItemValidity')
                {
                    return 'btn-info'
                }
            }
            else if(link ==='MyGoodsBuy')
            {
                if(this.$route.name === 'MyGoodsBuy')
                {
                    return 'btn-info'
                }
            }
            else if(link ==='myChild')
            {
                if(this.$route.name === 'myChildReward' || this.$route.name === 'myChildList')
                {
                    return 'btn-info'
                }
            }
            else if(link === 'leave_service')
            {
                if(this.$route.name === 'leave_service')
                {
                    return 'btn-info'
                }
                // }else{
                //      return 'btn-danger'    
                // }
            }
            else if(this.$route.name === link)
            {
                return 'btn-info'
            }else{
                return null
            }


        }
    }
}
</script>
<style lang="scss" scoped>
.mypage_wrapper{
    background:#fff;
    border: 1px solid #dee3eb;
    font-family: '맑은고딕';
    .header{
        .bg_area{
            background:#000;
            height:150px;
        }
        .menu_area{
            margin-top:-60px;
            display: flex;
            justify-content: space-between;
            .menu_block{
                padding:70px 20px;
                //width:40%;
            }
            .profileImg{
                background:#000;
                width:120px;
                height:120px;
                border-radius: 60px;
                border:3px solid #fff;
                background-size:cover;
                background-position:center;
               
            }
            .right_menu{
                display: flex;
                justify-content: flex-end;
            }
        }

    }
}
</style>
